import { CultureInfo } from '../culture-info.model';
import { CultureInfoNso } from './nso';

/**
 * @ignore
 */
export const CultureInfoNsoZA: CultureInfo = {
  name: 'nso-ZA',
  displayName: 'Northern Sotho (South Africa)',
  iso3LanguageCode: 'nso',
  iso2LanguageCode: 'nso',
  ietfLanguageTag: 'nso-ZA',
  parent: CultureInfoNso
};
